import { FormField } from '../models/form-builder/form-field.model';

export class FormFieldUtil {
    public static getFieldName(formField: FormField): string {
        return (formField.displayName != null) && (formField.displayName.trim() != '') ? formField.displayName : formField.name;
    }
}
